import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";
import { ISystemControlPromiseLookupService } from "../ISystemControlPromiseLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Subject } from "rxjs";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SystemControlReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.SystemControlImpl>
  implements ISystemControlPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.SystemControlImpl, "SystemControlImpl", CubiqTS.SystemControlImpl, true);
  }

  setSystemStatus(systemControl: CubiqTS.SystemControlImpl): Promise<void> {
    let request = new UiArguments("setSystemStatus");
    let arg1 = new FnArg(systemControl, CubiqTS.ENCODABLE(CubiqTS.SystemControlImpl));
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
